module.exports = __webpack_public_path__ + "img/engraneEtapa.8c556500.svg";